<template>
  <div>
    <RepaymentHead />
    <div class="myprofile-inf">
      <p style="font-size:20px; font-weight: 700;">{{ myorifileInf }}</p>
    </div>
    <div style="background-color: #a95159">
      <div class="myprofile-center">
        <div class="left">
          <div class="img-box">
            <img src="../assets/image/sfxx.png" alt  />
          </div>
          <div class="span">
            <span style="font-size:20px">Submit ldentify Picture</span>
          </div>
        </div>
        <div class="right" @click="go1">
          <div>
            <span class="span-font"><{{ IDinformation }}></span>
          </div>
<!--          <div class="img-box">-->
<!--            <img src="../assets/image/icons8-goto.png" />-->
<!--          </div>-->
        </div>
      </div>
      <div class="myprofile-center">
        <div class="left">
          <div class="img-box">
            <img src="../assets/image/skyhk.png" alt />
          </div>
          <div class="span">
            <span style="font-size:20px">Submit Personal info</span>
          </div>
        </div>
        <div class="right" @click="go2">
          <div>
            <span class="span-font"><{{ Information }}></span>
          </div>
<!--          <div class="img-box">-->
<!--            <img src="../assets/image/icons8-goto.png" />-->
<!--          </div>-->
        </div>
      </div>
      <div class="myprofile-center">
        <div class="left">
          <div class="img-box">
            <img src="../assets/image/zlxx.png" alt />
          </div>
          <div class="span">
            <span style="font-size:20px;">Submit Bank Account</span>
          </div>
        </div>
        <div class="right" @click="go3">
          <div>
            <span class="span-font"><{{Borrowingbankcard}}></span>
          </div>
<!--          <div class="img-box">-->
<!--            <img src="../assets/image/icons8-goto.png" />-->
<!--          </div>-->
        </div>
      </div>
      <div class="myprofile-center">
        <div class="left">
          <div class="img-box">
            <img src="../assets/image/zm.png" alt />
          </div>
          <div class="span">
            <span style="font-size:20px">Signature</span>
          </div>
        </div>
        <div class="right" @click="go4">
          <div>
            <span class="span-font"><{{ Signature }}></span>
          </div>
<!--          <div class="img-box">-->
<!--            <img src="../assets/image/icons8-goto.png" />-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div class="center">
      <div class="myprofile-bottom" @click="back">Submit</div>
    </div>
  </div>
</template>

<script>
import RepaymentHead from "../components/RepaymentHead.vue";
import axios from "axios";
export default {
  name: "",
  components: {
    RepaymentHead
  },
  mounted() {
    axios
      .get(
        `/puserSys/puser/selectIDCard?id=${+sessionStorage.getItem("token")}`
      )
      .then(res => {
        try {
          if (res.data.code != 401) {
            // ////console.log(res);
            if (res.data.data[0] != null) {
              if (
                res.data.data[0].backidcard != "" &&
                res.data.data[0].frontidcard != "" &&
                res.data.data[0].holdingidcard != "" &&
                res.data.data[0].idcard != "" &&
                res.data.data[0].name != ""
              ) {
                this.IDinformation = "complete";
              }
            }
          }
        } catch {}
      });

    let token = sessionStorage.getItem("token");
    // //////console.log(token)
    axios
      .get(`/puserSys/puser/selectInfo?id=${+token}`)
      .then(res => {
      //  ////console.log(res);
        if (res.data.code != 401) {
          if (res.data.data[0] != null) {
            if (
              res.data.data[0].address != "" &&
              res.data.data[0].educationalbackground != "" &&
              res.data.data[0].expectedamount != "" &&
              res.data.data[0].marriage != "" &&
              res.data.data[0].monthlylncome != "" &&
              res.data.data[0].purpose != ""
            ) {
              this.Information = "complete";
            }
            //////console.log(res);
          }
        }
      })
      .catch(() => {});

    axios
      .get(
        `/agreement/agreement/selectAutograph?uid=${+sessionStorage.getItem(
          "token"
        )}`
      )
      .then(res => {
   //  ////console.log(res.data);
        try {
          if (res.data.data.length != 0) {
            if (res.data.data[0].autograph != ""&&res.data.data[0].autograph != null) {
              this.Signature = "complete";
            }
          }
        } catch {}
      });

    axios
      .get(`/userbank/userbank/selectBank?uid=${+token}`)
      .then(res => {
     //  ////console.log(res);
        if (res.data.data.length != 0) {
          if (
            res.data.data[0].bankcard != "" &&
            res.data.data[0].bankname != ""
          ) {
            this.Borrowingbankcard = "complete";
          }
        }
      })
      .catch(() => {});
  },
  data() {
    return {
      myorifileInf:
        "Please Fill Your Personal Info",
      incomplete: "incomplete",

      IDinformation: "incomplete",
      Information: "incomplete",
      Borrowingbankcard: "incomplete",
      Signature: "incomplete"
    };
  },
  methods: {
    go1() {
      this.$router.push("/idInformation");
    },
    go2() {
      this.$router.push("/Information");
    },
    go3() {
      this.$router.push("/Rbc");
    },
    go4() {
      this.$router.push("/Signature");
    },
    back() {
      this.$router.push("/");
    }
  }
};
</script>

<style>
.span span {
  overflow: hidden;
  text-align: unset;
}
.myprofile-inf {
  height: auto;
  background-color: #E40D2C;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-size: 15px;
  text-align: center;
  position: relative;
  margin-top: 70px;
}

.myprofile-center {
  color: white;
  height: 70px;
  padding: 0 5%;
  display: flex;
}

.myprofile-center .left,
.myprofile-center .right {
  display: flex;
}

.left .right {
  position: relative;
  display: flex;
  cursor: pointer;
}

.left {
  margin-right: auto;
}
.left .span {
}

.left .img-box {
  width: 30px;
  margin-right: 10px;
}

.right span {
  margin-right: 10px;
}

.left span,
.right span {
  vertical-align: middle;
}
.left .img-box img {
  width: 100%;
  height: auto;
}

.right .img-box img {
  width: 50%;
  height: auto;
  cursor: pointer;
}
.center {
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.myprofile-bottom {
  width: 97.5%;
  position: fixed;
  color: #fff;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 25px;
  font-weight: 700;
  background-color: #E40D2C;
}
.span-font{
  font-size: 20px;
}
</style>
